export const joannaMaciejewska = {
    'firstName': 'Joanna',
    'lastName': 'Maciejewska',
    'mydrId': 'joannamaciejewska',
    'profession': 'Psychoterapeuta, psycholog, pedagog',
    'avatar': 'joanna-maciejewska.webp',
    'slug': 'psychoterapeuta-psycholog-pedagog-joanna-maciejewska',
    'locations': ['bydgoszcz'],
    'services': [
        ['psychoterapy', 'children'],
        ['psychoterapy', 'adult'],
        ['psychoterapy', 'parents'],
        ['psychoterapy', 'family'],
        ['psychoterapy', 'pair'],
    ]
}